const env: string = 'prod';

export function getWorkflowURI() {
  return process.env.APP_WORKFLOW_URI;
}

export function getKisaanBaseURL() {
  return process.env.APP_KISAN_URI;
}

export function getQnAURI() {
  return process.env.APP_QNA_URI;
}

export function getQnANewURI() {
  return process.env.APP_QNA_NEW_URI;
}

function getGlobalSearchApi(payload, selectedCategory) {
  console.log('payload selectedCategory *****', selectedCategory);
  let url = `${getKisaanBaseURL()}/kisaan/search/p/global?search=${payload.search}`;
  if (selectedCategory === 'all') {
    url += `&type=Qna&type=Feed&type=Stream`;
  } else if (selectedCategory === 'videos') {
    url += `&type=Stream`;
  } else if (selectedCategory === 'QNA') {
    url += `&type=Qna`;
  } else if (selectedCategory === 'Feed') {
    url += `&type=Feed`;
  }
  url += `&from=${payload?.from}&size=${payload?.size}`;

  return url;
}
export function getWorkflowV2URI() {
  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in' : 'apiv2.trafyn.info';
  // let returnUrl = `https://${baseUrl}/workflow-engine`;
  // return returnUrl;
  return process.env.APP_WORKFLOW_URI_V2;
}

const paths = {
  globalSearchAPIV2: (payload, selectedCategory) =>
    `${getGlobalSearchApi(payload, selectedCategory)}`,
  autoSuggestSearch: (search) =>
    `${getKisaanBaseURL()}/kisaan/global/p/auto/suggester?search=${search}`,
  updateFollowStatus: (type: string) => `${getKisaanBaseURL()}/kisaan/user/associations/${type}`,
  getConnectionList: (payload) => {
    const kisanFollowUrl = `${getKisaanBaseURL()}/kisaan/user/${payload?.userId}/${payload?.realmId}/follow/stats`;
    const queryParams = `?offset=${payload?.offset}&count=${payload?.count}&type=${payload?.type}`;
    const targetUserIdParam = payload?.targetUserId ? `&targetUserId=${payload?.targetUserId}` : '';

    return `${kisanFollowUrl}${queryParams}${targetUserIdParam}`;
  },
  getAllQuestionsApi: (payload) =>
    `${getQnANewURI()}/p/list?includeReplies=${payload?.includeReplies}&limit=${payload?.limit}&page=${payload?.page}&desc=${payload?.desc}&realmId=${payload?.realmId}&userId=${payload?.userId}&tags=${payload?.tags}`,
  getPostDetailApi: (payload) =>
    `${getWorkflowV2URI()}/kisaan/qna/p/detail/${payload?.id}?userId=${payload?.userId}&realmId=${payload?.realmId}`,
  getQuestionsByUserApi: (payload) =>
    `${getQnANewURI()}/list/me?includeReplies=${payload?.includeReplies}&page=${payload?.page}&desc=${payload?.desc}&limit=${payload?.limit}&realmId=${payload?.realmId}&userId=${payload?.userId}&tags=${payload?.tags}`,
  createCommentQnAApi: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/comments?notificationsDisabled=true`,
  likeReply: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts/${payload.id}/like`,
  getAllCommentsAgainstPost: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts/${payload?.id}/comments`,
};

export default paths;
